export const HomeNav = [
	{
		icon: 'pe-7s-home',
		label: 'Hem',
		to: '/'
	}
]

export const PageNav = [
	{
		icon: 'pe-7s-browser',
		label: 'Så funkar det',
		to: '/sa-funkar-det'
	},
	{
		icon: 'pe-7s-info',
		label: 'Om oss',
		to: '/om-oss'
	},
	/*{
		icon: 'pe-7s-id',
		label: 'Lärarteamet',
		to: '/lararteamet'
	},*/
	{
		icon: 'pe-7s-smile',
		label: 'Kundcase',
		to: '/kundcase'
	},
	{
		icon: 'pe-7s-calculator',
		label: 'Begär offert',
		to: '/begar-offert'
	}
]

export const SchoolTypeNav = [
	{
		icon: 'pe-7s-study',
		label: 'Vuxenutbildning',
		to: '/vuxenutbildning'
	},
	{
		icon: 'pe-7s-study',
		label: 'Folkhögskola',
		to: '/folkhogskola'
	},
	{
		icon: 'pe-7s-study',
		label: 'Gymnasieskola',
		to: '/gymnasieskola'
	},
	{
		icon: 'pe-7s-study',
		label: 'Grundskola',
		to: '/grundskola'
	}
]

export const SocialMediaNav = [
	{
		icon: 'pe-7s-global',
		label: 'Facebook',
		to: 'https://wwww.facebook.com/lektionsakuten'
	},
	{
		icon: 'pe-7s-global',
		label: 'Instagram',
		to: 'https://www.instagram.com/lektionsakuten_sverige/'
	},
	{
		icon: 'pe-7s-global',
		label: 'LinkedIn',
		to: 'https://www.linkedin.com/company/lektionsakuten/'
	}
]
